module.exports = __webpack_public_path__ + "static/img/2179_phase_function_Paper_PointsHejduk_Prediction.f9673d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2179_phase_function_Paper_PointsHejduk_Prediction.png
// module id = X+t4
// module chunks = 0